module.exports = __webpack_public_path__ + "img/img_dwcr.94a55748.png";